
(function() {
  'use strict';

  const _cfgEl = document.getElementById('cdf-main-config');
  if (!_cfgEl) return;
  const CFG = JSON.parse(_cfgEl.textContent);

  const ST = {
    initialized: false,
    timerInterval: null,
    timerEndTime: null,
    isOurAction: false,
    isRefreshing: false,
    observerRef: null,
    debounceTimer: null,
    /* Flags pour savoir si chaque feature a déjà été affichée */
    giftShown: false,
    savingsShown: false,
    timerShown: false,
    urgencyShown: false,
    badgesShown: false
  };

  /* ===== UTILS ===== */
  const $ = s => document.querySelector(s);
  const $$ = s => document.querySelectorAll(s);
  function removeEl(s) {
    const el = typeof s === 'string' ? $(s) : s;
    try { if (el && el.parentNode) el.parentNode.removeChild(el); } catch(e) {}
  }
  function cloneTpl(id) {
    const t = $(id);
    if (!t) return null;
    return t.content.cloneNode(true).firstElementChild;
  }
  function getJSON(id) {
    const el = $(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  /* Créer un élément depuis un template, SANS animation si déjà montré */
  function createFromTpl(id, shownFlag) {
    const el = cloneTpl(id);
    if (!el) return null;
    if (shownFlag && CFG.animations) {
      el.classList.remove('cart-feature-animate');
      el.classList.add('cart-feature-no-anim');
    }
    return el;
  }

  /* Marquer comme animé (fin d'animation) */
  function markAnim(el) {
    if (CFG.animations && el) {
      setTimeout(() => { if (el.classList) el.classList.add('cart-feature-animated'); }, 400);
    }
  }

  function updateScript(id, doc) {
    const nw = doc.querySelector(id);
    const old = document.querySelector(id);
    if (nw && old) old.textContent = nw.textContent;
    else if (nw && !old) {
      const ref = $('cart-drawer');
      if (ref) ref.insertAdjacentElement('beforebegin', nw.cloneNode(true));
    }
  }
  function updateTpl(id, doc) {
    const nw = doc.querySelector(id);
    const old = document.querySelector(id);
    if (nw && old) old.innerHTML = nw.innerHTML;
    else if (nw && !old) {
      const ref = $('cart-drawer');
      if (ref) ref.insertAdjacentElement('beforebegin', nw.cloneNode(true));
    }
  }

  /* ===== TIMER ===== */
  const Timer = {
    init() {
      if (!CFG.timer.enabled) return;
      const cd = $('cart-drawer');
      if (!cd || cd.classList.contains('is-empty')) { this.clear(); return; }
      const stored = localStorage.getItem('cartTimerEndTime');
      const now = Date.now();
      if (stored && parseInt(stored) > now) ST.timerEndTime = parseInt(stored);
      else {
        ST.timerEndTime = now + CFG.timer.minutes * 60000;
        localStorage.setItem('cartTimerEndTime', ST.timerEndTime.toString());
      }
      this.render();
      this.start();
    },
    render() {
      /* Si déjà présent dans le DOM, ne rien faire */
      if ($('[data-cart-feature="timer"]')) return;

      const el = createFromTpl('#cart-timer-tpl', ST.timerShown);
      if (!el) return;
      el.id = 'cart-timer';
      let t;
      switch (CFG.timer.position) {
        case 'top': t = $('#CartDrawer .drawer__header'); if (t) t.insertAdjacentElement('afterend', el); break;
        case 'bottom': t = $('#CartDrawer .drawer__footer'); if (t) t.insertAdjacentElement('afterbegin', el); break;
        case 'above_checkout': t = $('#CartDrawer .cart__ctas'); if (t) t.insertAdjacentElement('beforebegin', el); break;
      }
      if (!ST.timerShown) markAnim(el);
      ST.timerShown = true;
    },
    start() {
      if (ST.timerInterval) clearInterval(ST.timerInterval);
      ST.timerInterval = setInterval(() => this.tick(), 1000);
      this.tick();
    },
    tick() {
      const d = $('#cart-timer-display'), t = $('#cart-timer');
      if (!d || !t) return;
      const r = Math.max(0, ST.timerEndTime - Date.now());
      if (r <= 0) { this.expire(); return; }
      const m = Math.floor(r / 60000), s = Math.floor((r % 60000) / 1000);
      d.textContent = `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      if (CFG.timer.showWarning && m < CFG.timer.warningMinutes) t.classList.add('cart-timer-warning');
      else t.classList.remove('cart-timer-warning');
    },
    expire() {
      if (ST.timerInterval) { clearInterval(ST.timerInterval); ST.timerInterval = null; }
      const t = $('#cart-timer'), d = $('#cart-timer-display');
      if (t && d) {
        t.classList.add('cart-timer-expired'); t.classList.remove('cart-timer-warning');
        d.textContent = '00:00';
        const tx = t.querySelector('.cart-timer-text'); if (tx) tx.textContent = CFG.timer.expiredText;
      }
      fetch('/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json'} })
        .then(() => { localStorage.removeItem('cartTimerEndTime'); location.reload(); });
    },
    clear() {
      if (ST.timerInterval) { clearInterval(ST.timerInterval); ST.timerInterval = null; }
      localStorage.removeItem('cartTimerEndTime');
      $$('[data-cart-feature="timer"]').forEach(el => removeEl(el));
      ST.timerShown = false;
    }
  };

  /* ===== GIFT ===== */
  const Gift = {
    cfg: null,
    init() {
      if (!CFG.gift.enabled) return;
      this.cfg = getJSON('#cart-gift-config');
      if (!this.cfg || !this.cfg.enabled) return;

      if (this.cfg.shouldShow) {
        this.showVisuals();
        this.hideRealGiftRow();
      } else {
        this.removeVisuals();
      }

      if (this.cfg.action === 'add') this.addGift();
      else if (this.cfg.action === 'remove') this.removeGift();
    },

    showVisuals() {
      /* Message : ne créer QUE s'il n'existe pas déjà */
      if (!$('[data-cart-feature="gift-message"]')) {
        const msg = createFromTpl('#cart-gift-message-tpl', ST.giftShown);
        if (msg) {
          const h = $('#CartDrawer .drawer__header');
          if (h) {
            h.insertAdjacentElement('afterend', msg);
            if (!ST.giftShown) markAnim(msg);
          }
        }
      }

      /* Item : ne créer QUE s'il n'existe pas déjà */
      if (!$('[data-cart-feature="gift-item"]')) {
        const item = createFromTpl('#cart-gift-item-tpl', ST.giftShown);
        if (item) {
          const w = $('#CartDrawer .drawer__cart-items-wrapper');
          if (w) {
            w.insertAdjacentElement('afterend', item);
            if (!ST.giftShown) markAnim(item);
          }
        }
      }

      ST.giftShown = true;
    },

    removeVisuals() {
      $$('[data-cart-feature="gift-message"]').forEach(el => removeEl(el));
      $$('[data-cart-feature="gift-item"]').forEach(el => removeEl(el));
      ST.giftShown = false;
    },

    hideRealGiftRow() {
      if (!this.cfg) return;
      const vid = this.cfg.giftVariantId;
      $$(`#CartDrawer [data-variant-id="${vid}"]`).forEach(btn => {
        const row = btn.closest('tr.cart-item');
        if (row) row.classList.add('cart-item--is-gift');
      });
    },

    addGift() {
      ST.isOurAction = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: this.cfg.giftVariantId, quantity: 1, properties: { '_gift': 'true' } }]
        })
      })
      .then(r => { if (!r.ok) throw new Error('add failed'); })
      .then(() => refreshDrawerContent())
      .catch(e => console.error('Gift add:', e))
      .finally(() => {
        setTimeout(() => { ST.isOurAction = false; }, 1200);
      });
    },

    removeGift() {
      if (!this.cfg.giftLineKey) return;
      ST.isOurAction = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.cfg.giftLineKey, quantity: 0 })
      })
      .then(r => { if (!r.ok) throw new Error('remove failed'); })
      .then(() => refreshDrawerContent())
      .catch(e => console.error('Gift remove:', e))
      .finally(() => {
        setTimeout(() => { ST.isOurAction = false; }, 1200);
      });
    }
  };

  /* ===== SAVINGS ===== */
  const Savings = {
    init() {
      if (!CFG.savings.enabled) return;
      const cfg = getJSON('#cart-savings-config');

      if (!cfg || !cfg.enabled || !cfg.hasSavings) {
        /* Pas d'économies → supprimer si existant */
        $$('[data-cart-feature="savings"]').forEach(el => removeEl(el));
        ST.savingsShown = false;
        return;
      }

      const existing = $('[data-cart-feature="savings"]');
      if (existing) {
        /* Déjà affiché → mettre à jour le contenu SANS re-créer */
        const freshEl = cloneTpl('#cart-savings-tpl');
        if (freshEl) {
          existing.innerHTML = freshEl.innerHTML;
        }
        return;
      }

      /* Pas encore affiché → créer */
      const el = createFromTpl('#cart-savings-tpl', ST.savingsShown);
      if (!el) return;
      let t; const p = cfg.position || CFG.savings.position;
      switch (p) {
        case 'above_total': t = $('#CartDrawer .totals'); if (t) t.insertAdjacentElement('beforebegin', el); break;
        case 'below_total': t = $('#CartDrawer .totals'); if (t) t.insertAdjacentElement('afterend', el); break;
        case 'above_checkout': t = $('#CartDrawer .cart__ctas'); if (t) t.insertAdjacentElement('beforebegin', el); break;
      }
      if (!ST.savingsShown) markAnim(el);
      ST.savingsShown = true;
    }
  };

  /* ===== URGENCY ===== */
  const Urgency = {
    init() {
      if (!CFG.urgency.enabled) return;
      const cd = $('cart-drawer');
      if (!cd || cd.classList.contains('is-empty')) {
        $$('[data-cart-feature="urgency"]').forEach(el => removeEl(el));
        ST.urgencyShown = false;
        return;
      }
      if ($('[data-cart-feature="urgency"]')) return;
      const el = createFromTpl('#cart-urgency-tpl', ST.urgencyShown);
      if (!el) return;
      const t = $('#CartDrawer .drawer__cart-items-wrapper');
      if (t) {
        t.insertAdjacentElement('beforebegin', el);
        if (!ST.urgencyShown) markAnim(el);
        ST.urgencyShown = true;
      }
    }
  };

  /* ===== TRUST BADGES ===== */
  const TrustBadges = {
    init() {
      if (!CFG.trustBadges.enabled) return;
      if ($('[data-cart-feature="trust-badges"]')) return;
      const el = createFromTpl('#cart-trust-badges-tpl', ST.badgesShown);
      if (!el) return;
      const t = $('#CartDrawer .cart__ctas');
      if (t) {
        t.insertAdjacentElement('afterend', el);
        if (!ST.badgesShown) markAnim(el);
        ST.badgesShown = true;
      }
    }
  };

  /* =============================================
     REFRESH DRAWER CONTENT
     Appelé SEULEMENT après nos propres actions (ajout/suppression cadeau)
  ============================================= */
  function refreshDrawerContent() {
    if (ST.isRefreshing) return Promise.resolve();
    ST.isRefreshing = true;

    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCD = doc.querySelector('#CartDrawer');
        const oldCD = document.querySelector('#CartDrawer');

        if (newCD && oldCD) {
          oldCD.innerHTML = newCD.innerHTML;

          /* Re-bind overlay */
          const overlay = oldCD.querySelector('#CartDrawer-Overlay');
          const drawerEl = document.querySelector('cart-drawer');
          if (overlay && drawerEl && typeof drawerEl.close === 'function') {
            overlay.addEventListener('click', () => drawerEl.close());
          }

          /* Mettre à jour is-empty */
          const newWrapper = doc.querySelector('cart-drawer');
          if (newWrapper && drawerEl) {
            if (newWrapper.classList.contains('is-empty')) drawerEl.classList.add('is-empty');
            else drawerEl.classList.remove('is-empty');
          }
        }

                /* Mettre à jour le compteur panier */
        const newBubbles = doc.querySelectorAll('.cart-count-bubble');
        const oldBubbles = document.querySelectorAll('.cart-count-bubble');
        if (newBubbles.length > 0) {
          oldBubbles.forEach(oldB => {
            oldB.innerHTML = newBubbles[0].innerHTML;
          });
        } else {
          oldBubbles.forEach(oldB => {
            oldB.textContent = '';
            oldB.style.display = 'none';
          });
        }
        /* Aussi mettre à jour les spans de compteur */
        const newCounts = doc.querySelectorAll('.cart-count-bubble span[aria-hidden]');
        const oldCounts = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
        if (newCounts.length > 0 && oldCounts.length > 0) {
          oldCounts.forEach((oldC, i) => {
            if (newCounts[i]) oldC.textContent = newCounts[i].textContent;
          });
        }

        /* Mettre à jour configs et templates */
        updateScript('#cart-gift-config', doc);
        updateScript('#cart-savings-config', doc);
        updateTpl('#cart-savings-tpl', doc);

        /* Réinitialiser - les éléments ont été supprimés par innerHTML
           mais les flags shownfont qu'il n'y aura PAS d'animation */
        ST.initialized = false;
        initFeatures();

        /* Ré-attacher l'observer */
        setupObserver();
      })
      .catch(e => console.error('CartFeatures refresh:', e))
      .finally(() => {
        ST.isRefreshing = false;
      });
  }

  /* =============================================
     FETCH CONFIGS ONLY
     Appelé quand Dawn re-render le drawer
     NE touche PAS au HTML de Dawn
  ============================================= */
  function fetchConfigsAndReinit() {
    if (ST.isRefreshing || ST.isOurAction) return;
    ST.isRefreshing = true;

    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        /* Mettre à jour SEULEMENT les configs JSON et templates */
        updateScript('#cart-gift-config', doc);
        updateScript('#cart-savings-config', doc);
        updateTpl('#cart-savings-tpl', doc);

        /* Réinitialiser sans nettoyer
           Chaque module gère ses propres éléments */
        ST.initialized = false;
        initFeatures();
      })
      .catch(e => console.error('CartFeatures fetchConfigs:', e))
      .finally(() => { ST.isRefreshing = false; });
  }

  /* =============================================
     OBSERVER
  ============================================= */
  function setupObserver() {
    const target = $('#CartDrawer');
    if (!target) return;
    if (ST.observerRef) ST.observerRef.disconnect();

    const observer = new MutationObserver(mutations => {
      if (ST.isOurAction || ST.isRefreshing) return;

      let hasRealChange = false;
      for (const m of mutations) {
        if (m.type !== 'childList') continue;
        const nodes = [...m.addedNodes, ...m.removedNodes];
        for (const n of nodes) {
          if (n.nodeType !== 1) continue;
          if (!n.getAttribute || !n.getAttribute('data-cart-feature')) {
            hasRealChange = true;
            break;
          }
        }
        if (hasRealChange) break;
      }
      if (!hasRealChange) return;

      /* Réinsertion immédiate avec les données déjà en mémoire (évite le clignotement
         du timer/remise après un ajout/suppression), puis rafraîchissement des configs
         en arrière-plan (mise à jour du contenu sans re-création, cf. Savings.init) */
      ST.initialized = false;
      initFeatures();

      clearTimeout(ST.debounceTimer);
      ST.debounceTimer = setTimeout(() => {
        if (ST.isOurAction || ST.isRefreshing) return;
        fetchConfigsAndReinit();
      }, 400);
    });

    observer.observe(target, { childList: true, subtree: true });
    ST.observerRef = observer;
  }

  /* =============================================
     INIT
  ============================================= */
  function initFeatures() {
    if (ST.initialized) return;
    const d = $('#CartDrawer .drawer__inner');
    if (!d) { setTimeout(initFeatures, 50); return; }

    ST.isOurAction = true;
    Timer.init();
    Gift.init();
    Savings.init();
    Urgency.init();
    TrustBadges.init();
    ST.initialized = true;
    setTimeout(() => { ST.isOurAction = false; }, 100);
  }

  /* =============================================
     EVENTS
  ============================================= */
  function setupEvents() {
    document.addEventListener('click', (e) => {
      const isTrigger = e.target.closest(
        '.cart-icon-bubble, .header__icon--cart, a[href="/cart"], ' +
        '[data-cart-button], .cart-count-bubble, ' +
        'button[name="add"], .product-form__submit, .shopify-payment-button__button'
      );
      if (isTrigger) {
        setTimeout(() => {
          ST.initialized = false;
          initFeatures();
          setupObserver();
        }, 300);
      }
    });
  }

  /* =============================================
     START
  ============================================= */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initFeatures(); setupObserver(); setupEvents(); });
  } else {
    initFeatures();
    setupObserver();
    setupEvents();
  }

  window.CartFeatures = {
    Timer, Gift, Savings, Urgency, TrustBadges, ST, CFG,
    refresh: () => refreshDrawerContent(),
    reinit: () => { ST.initialized = false; initFeatures(); }
  };
})();
